import { isObject } from '../../type-guards/is-object';
import { copyArray } from './copy-array';
import { copyObject } from './copy-object';

const cloneDeep = <T>(item: T): T => {
  if (!isObject(item)) {
    return item;
  }

  if (Array.isArray(item)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return copyArray(item);
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return copyObject(item);
};

export { cloneDeep };
